module.exports = new __parcel__URL__("danger-triangle.f0b9b384.svg").toString();